###
This filter formats a date (using Moment.js).

input       A date string
outputFormat  An output format string, using Moment's formating conventions
inputFormat   An optional input format string, using Moment's formating conventions
        By default the input format is set to 'YYYY-MM-DD HH:mm:ss'


Example:

```html
<span>
  Created at
  {{view.date | dateFormat:"dddd, MMMM D, YYYY":}}
  at 
  {{view.date | dateFormat:"HH:mm A"}}
</span>
```
###
angular.module('rjmNg.common.filters').filter "dateFormat", [
  () ->
    (input, outputFormat, inputFormat = 'YYYY-MM-DD HH:mm:ss') ->
     return moment(input, inputFormat).format(outputFormat)
]
